import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { MessageCoverProps } from "../../interface/messages";
import { useTheme } from "@mui/material/styles";
import { formatTime } from "../../utils/date-setup";
import { useDispatch } from "react-redux";
import { setChartId, setReceiverId } from "../../store/messageSlice";

const MessageCover = ({
  image,
  name,
  message,
  selectChat,
  chatId,
  time,
  updateChartHeader,
  chat_number,
}: MessageCoverProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const handleSelectedMessage = (data: any) => {
    updateChartHeader({
      id: chatId,
      name: name,
      photo_url: image,
    });
    dispatch(setChartId(chatId));
    dispatch(setReceiverId(chatId))
    selectChat(chatId);
  };
  return (
    <Box sx={{ my: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "94%",
          marginHorizontal: "auto",
          cursor: "pointer",
        }}
        onClick={() => handleSelectedMessage(chatId)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "75%",
            gap: 2,
          }}
        >
          <img
            alt="i"
            src={image}
            style={{ width: 50, height: 50, borderRadius: 40 }}
          />
          <Stack>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 600,
                color: "#141414",
              }}
            >
              {name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                color: "#A8A9B2",
              }}
            >
              {message}
            </Typography>
          </Stack>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: 1,
          }}
        >
          <Typography sx={{ fontSize: 10, color: "#A8A9B2", fontWeight: 600 }}>
            {formatTime(time)}
          </Typography>
          {chat_number > 0 && (
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              style={{
                width: 20,
                height: 20,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 40,
              }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  color: "#ffffff",
                }}
              >
                {chat_number}
              </Typography>
            </Stack>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MessageCover;
